/**
 * Cottage Sub-navigation - Dynamic price and Book button sync with One Line Calendar
 */
(function() {
  'use strict';

  function formatPrice(n) {
    var num = parseInt(n, 10);
    if (isNaN(num)) return '';
    return '$' + num.toLocaleString();
  }

  function isTotalValid(totalText) {
    if (!totalText || typeof totalText !== 'string') return false;
    var t = totalText.trim();
    return t.length > 0 && t !== '$0.00' && /^\$[\d,]+(\.\d{2})?$/.test(t);
  }

  function updateSubnav(subnav, calendar) {
    if (!calendar) return;
    var totalEl = calendar.querySelector('[data-total]');
    var priceEl = subnav.querySelector('[data-subnav-price-value]');
    var prefixEl = subnav.querySelector('[data-subnav-price-prefix]');
    var btn = subnav.querySelector('[data-subnav-book]');
    var btnTextEl = btn ? btn.querySelector('.btn__text') : null;
    if (!priceEl) return;

    var pricePerNight = calendar.dataset.pricePerNight || '';
    var totalText = totalEl ? totalEl.textContent : '';
    var datesSelected = isTotalValid(totalText);
    var defaultBtnText = subnav.dataset.buttonText || 'Book';

    if (datesSelected) {
      var nights = calendar.dataset.nights ? parseInt(calendar.dataset.nights, 10) : 0;
      var nightsText = nights > 0 ? (nights === 1 ? '1 night' : nights + ' nights') : totalText;
      if (prefixEl) prefixEl.style.display = 'none';
      priceEl.textContent = nightsText;
      if (btnTextEl) btnTextEl.textContent = 'Book now';
      if (btn) btn.setAttribute('aria-label', 'Book now');
    } else {
      if (prefixEl) prefixEl.style.display = '';
      priceEl.textContent = pricePerNight ? formatPrice(pricePerNight) : '';
      if (btnTextEl) btnTextEl.textContent = defaultBtnText;
      if (btn) btn.setAttribute('aria-label', defaultBtnText);
    }
  }

  function setupBookButton(subnav, calendar) {
    var btn = subnav.querySelector('[data-subnav-book]');
    var anchor = subnav.dataset.buttonAnchor || 'details';
    if (!btn || !calendar) return;

    btn.addEventListener('click', function() {
      var bookBtn = calendar.querySelector('[data-book-btn]');
      if (bookBtn && !bookBtn.disabled) {
        bookBtn.click();
      } else {
        var target = document.getElementById(anchor);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  function setupNavLinks(subnav) {
    var links = subnav.querySelectorAll('.cottage-subnav__link[href^="#"]');
    links.forEach(function(link) {
      link.addEventListener('click', function(e) {
        var id = (link.getAttribute('href') || '').slice(1);
        if (!id) return;
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  }

  function setupFooterVisibility(subnavs, footer) {
    var observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          var isFooterVisible = entry.isIntersecting;
          subnavs.forEach(function(subnav) {
            subnav.classList.toggle('cottage-subnav--hidden', isFooterVisible);
          });
        });
      },
      { threshold: 0 }
    );
    observer.observe(footer);
  }

  function init() {
    var subnavs = document.querySelectorAll('[data-cottage-subnav]');
    var calendar = document.querySelector('.one-line-calendar[data-price-per-night]');
    var footer = document.querySelector('[data-footer]');

    if (subnavs.length && footer) {
      setupFooterVisibility(subnavs, footer);
    }

    subnavs.forEach(function(subnav) {
      setupNavLinks(subnav);
    });

    if (!subnavs.length || !calendar) return;

    function syncSubnavs() {
      subnavs.forEach(function(subnav) {
        updateSubnav(subnav, calendar);
      });
    }

    subnavs.forEach(function(subnav) {
      updateSubnav(subnav, calendar);
      setupBookButton(subnav, calendar);
    });

    document.addEventListener('hanalei:booking-update', syncSubnavs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
